import { init as initApm } from '@elastic/apm-rum';

if (process.env.ELASTIC_APM_SERVER_URL) {
  initApm({
    serviceName: 'airr-frontend',
    serverUrl: process.env.ELASTIC_APM_SERVER_URL,
    environment: process.env.ELASTIC_APM_ENVIRONMENT,
  });
}
